module.exports = __webpack_public_path__ + "static/media/new-user.269f7be1.svg";